var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronPaginationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9429 0H13.0572L5.52869 7.52853L5.05729 8L5.52869 8.4714L13.0573 16H14.943L6.9429 8L14.9429 0ZM10.2763 16H8.39064L0.862028 8.4714L0.390625 8L0.862028 7.52853L8.39057 0H10.2762L2.27624 8L10.2763 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronPaginationLeft);
export default __webpack_public_path__ + "static/media/chevron-pagination-left.a57cd3e5b9a61c895c70fcf337b22078.svg";
export { ForwardRef as ReactComponent };